// Launch gates. Some claims are true only once something happens before the
// site goes live: a future feature ships (F1–F4, the Future Features doc) or
// a pre-launch item is done (C2–C15, docs/refresh/FEATURE_SHOWCASE.md Part C).
// Every gated phrase in src/content carries its gate. Set a gate to false and
// that phrase disappears from every page, with no other edit.
export const GATES = {
  F1: true, // White-label rooms
  F2: true, // AI-drafted Q&A answers
  F3: true, // Q&A answer approval
  F4: true, // Data isolation on request
  C2: true, // SSO, session revocation and deal pinning switched on in production
  C3: true, // Earnings-quality and concentration signals switched on
  C4: true, // Two-step sign-in requirement enforced
  C5: true, // Hardened deal entry available
  C8: true, // AI provider terms confirmed in writing (no training on documents)
  C10: true, // Lead replies within one business day
  C11: true, // Security documentation pack exists
  C12: true, // Security contact monitored
  C13: true, // "Trusted by" customers can be referenced
  C14: true, // Lead-form privacy line matches the Privacy Policy (reworded 2026-10-22)
  C15: true, // support@ and privacy@ mailboxes exist and are watched (off: both fall back to info@)
  // Not a launch item: on exactly when the build sets REACT_APP_GA_MEASUREMENT_ID,
  // the same value that loads Google Analytics (public/index.html), so the
  // Privacy Policy names it only while the site runs it.
  GA: /^G-[A-Z0-9]+$/.test(process.env.REACT_APP_GA_MEASUREMENT_ID || ''),
};

export const isOn = (gate) => !gate || GATES[gate] !== false;

// A list entry is a string or { text, gate } (or any object with a gate).
export const gated = (items) => items.filter((item) => typeof item === 'string' || isOn(item.gate));

// A paragraph is one string, or an array of sentences that may carry gates.
export const sentences = (body) =>
  Array.isArray(body)
    ? gated(body)
        .map((part) => (typeof part === 'string' ? part : part.text))
        .join(' ')
    : body;
